import { render, staticRenderFns } from "./TrackingRecords.vue?vue&type=template&id=c8e4bd24&scoped=true"
import script from "./TrackingRecords.vue?vue&type=script&lang=js"
export * from "./TrackingRecords.vue?vue&type=script&lang=js"
import style0 from "./TrackingRecords.vue?vue&type=style&index=0&id=c8e4bd24&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8e4bd24",
  null
  
)

export default component.exports